import { render, staticRenderFns } from "./HolidaysToApprove.vue?vue&type=template&id=321483c0&scoped=true&"
import script from "./HolidaysToApprove.vue?vue&type=script&lang=js&"
export * from "./HolidaysToApprove.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysToApprove.vue?vue&type=style&index=0&id=321483c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321483c0",
  null
  
)

export default component.exports